import type { VenueTransformed } from "~pages/Venues/types/venueTransformed.ts";
import type { Venue, VenueResources } from "~types/venue.ts";

export const transformVenue = (item: Venue, resources?: VenueResources): VenueTransformed => {
  const siteId = item.site?.id ?? item.siteId;
  const site = siteId ? resources?.sites?.[siteId] : undefined;

  return {
    ...item,
    site,
    siteName: site?.nameLocal ?? "",
  };
};
